export class Dealer {
  constructor({
    dealerID = null,
    ubDealerID = null,
    groupNo = null,
    dealerFullName = null,
    dealerEmail = null,
    authLevel = null,
    authGroup = null,
    lastLogedIn = null,
  } = {}) {
    this.dealerID = dealerID;
    this.ubDealerID = ubDealerID;
    this.groupNo = groupNo;
    this.dealerFullName = dealerFullName;
    this.dealerEmail = dealerEmail;
    this.authLevel = authLevel;
    this.authGroup = authGroup;
    this.lastLogedIn = lastLogedIn;
  }
}

export function createDealer(data) {
  return Object.freeze(new Dealer(data));
}
